package uk.co.nickthecoder.kyd.appearance

/**
 * Used by [NinePatch] to determine where the central patch is.
 *
 * FYI. The constructor's arguments are ordered in the same way as CSS :
 * top, right, bottom, left.
 */
class Margins(
    val top: Float = 0f,
    val right: Float = 0f,
    val bottom: Float = 0f,
    val left: Float = 0f
)
